import React from "react";

const QRCode = (props) => {
  return (
    <section className="toc" aria-hidden={props.isVisible}>
      <div className="toc-wrapper no-purchase__wrapper no-purchase__wrapper--qr">
        <button className="toc-close" onClick={() => props.toggleQR()}>
          close modal
        </button>
        <div className="toc-content no-purchase__content">
          <div className="no-purchase__title--sm">
            Scan the QR code to receive your <strong>{props.selectedArtist.alias}</strong> game piece.
          </div>
          <div className="np__qr" data-artist={props.selectedArtist.id} />
        </div>
      </div>
    </section>
  );
};

export default QRCode;
